import React from 'react';
import { ColDef } from 'ag-grid-community';
import { AgGridTable } from '@shared/components/ui/AgGridTable';
import { Invoice } from '../../models/Invoices';

interface InvoicesAgGridTableProps {
  invoices: Invoice[];
  columnDefs: ColDef[];
  isLoading?: boolean;
  isFetching?: boolean;
  fetchNextPage?: () => void;
  hasNextPage?: boolean;
  isFetchingNextPage?: boolean;
  sorting?: { field: string; direction: 'asc' | 'desc' } | null;
  onSortingChange?: (sorting: { field: string; direction: 'asc' | 'desc' } | null) => void;
}

export const InvoicesAgGridTable = React.memo(function InvoicesAgGridTable({
  invoices,
  columnDefs,
  isLoading = false,
  isFetching = false,
  fetchNextPage,
  hasNextPage,
  isFetchingNextPage,
  sorting,
  onSortingChange,
}: InvoicesAgGridTableProps) {
  return (
    <div className={isFetching ? 'opacity-50 pointer-events-none transition-opacity duration-200' : ''}>
      <AgGridTable
        data={invoices}
        columnDefs={columnDefs}
        height="calc(100vh - 150px)"
        enableSelection={false}
        isLoading={isLoading}
        rowHeight={56}
        fetchNextPage={fetchNextPage}
        hasNextPage={hasNextPage}
        isFetchingNextPage={isFetchingNextPage}
        sorting={sorting}
        onSortingChange={onSortingChange}
      />
    </div>
  );
});
